import Vue from "vue";
import monitor from "@/lib/monitor";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import zhijiTool from "@/views/zhiji/js/common/vueTool.js";
import "./registerServiceWorker";
import "@/assets/reset.less";
import "@/assets/element-ui.less";
import viserVue from "viser-vue";

import ElementUI from "element-ui";
import i18n from "./i18n";

Vue.use(ElementUI, {
    i18n: (key, value) => i18n.t(key, value)
});
Vue.use(zhijiTool);
Vue.use(viserVue);
Vue.use(monitor);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount("#app");
